var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    staticClass: "property-form",
    attrs: {
      "id": "property-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveProperty.apply(null, arguments);
      }
    }
  }, [_c('section', {
    staticClass: "property-card property-card--primary"
  }, [_vm._m(0), _c('div', {
    staticClass: "property-grid"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "hodnota-nehnutelnosti"
    }
  }, [_vm._v("Odhadovaná hodnota")]), _c('div', {
    staticClass: "input-with-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.hodnota,
      expression: "form.hodnota",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "name": "hodnota-nehnutelnosti",
      "id": "hodnota-nehnutelnosti",
      "required": ""
    },
    domProps: {
      "value": _vm.form.hodnota
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "hodnota", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_vm._v("EUR")])])]), _vm.propertyTypeHelper === 'not_specified' ? _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'druh_nehnutelnosti',
      "init-value": _vm.propertyTypes[0].value,
      "options": _vm.propertyTypes,
      "normal": "",
      "name": 'Druh nehnuteľnosti'
    },
    on: {
      "select": function select($event) {
        return _vm.selectSubTypeOfProperty($event);
      }
    }
  })], 1) : _vm._e(), _vm.subTypeData !== 'not_specified' ? _c('div', {
    staticClass: "dropdown-input-custom rest-input required"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'property_pravny_stav',
      "init-value": _vm.propertyTypeHelper === 'not_specified' ? null : _vm.form.pravny_stav,
      "value-removal": _vm.removePravnyStavValue,
      "options": _vm.getAccordingOptions(),
      "required": "",
      "normal": "",
      "name": 'Právny stav ' + _vm.type.label
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'pravny_stav');
      },
      "value-removed": function valueRemoved($event) {
        _vm.removePravnyStavValue = $event;
      }
    }
  })], 1) : _vm._e()]), _vm.form.pravny_stav === 'developersky_projekt' ? _c('div', {
    staticClass: "input-group property-full-width"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "developer-project"
    }
  }, [_vm._v("Názov developerského projektu")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.developersky_projekt_nazov,
      expression: "form.developersky_projekt_nazov",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "id": "developer-project"
    },
    domProps: {
      "value": _vm.form.developersky_projekt_nazov
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "developersky_projekt_nazov", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e()]), _c('section', {
    staticClass: "property-card"
  }, [_vm._m(1), _c('sidlo-input', {
    staticClass: "property-address",
    attrs: {
      "google-place-id": _vm.googlePlaceId,
      "type": _vm.typeData,
      "not-required": _vm.druh === 'zakladane_nehnutelnosti' && _vm.typeData === 'land' ? {
        street: true
      } : null,
      "property-meta": _vm.propertyMeta,
      "not-built": _vm.form.pravny_stav === 'rozostavana'
    },
    on: {
      "address-change": function addressChange($event) {
        return _vm.setAddress($event);
      }
    }
  }), _c('div', {
    staticClass: "property-grid property-grid--three"
  }, [_c('div', {
    staticClass: "input-group property-grid-span-2"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "cadastral-area"
    }
  }, [_vm._v("Katastrálne územie")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.katastralne_uzemie,
      expression: "form.katastralne_uzemie",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "id": "cadastral-area"
    },
    domProps: {
      "value": _vm.form.katastralne_uzemie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "katastralne_uzemie", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'property_kataster_register',
      "init-value": _vm.form.kataster_register,
      "options": _vm.katasterRegisters,
      "normal": "",
      "name": 'Register parcely'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'kataster_register');
      }
    }
  })], 1)])], 1), _vm.typeData !== 'land' ? _c('section', {
    staticClass: "property-card"
  }, [_vm._m(2), _c('div', {
    staticClass: "property-grid property-grid--three"
  }, [_vm.typeData === 'flat' ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "apartment-number"
    }
  }, [_vm._v("Číslo bytu / priestoru")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.cislo_priestoru,
      expression: "form.cislo_priestoru",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "text",
      "maxlength": "16",
      "id": "apartment-number"
    },
    domProps: {
      "value": _vm.form.cislo_priestoru
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "cislo_priestoru", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "floor-area"
    }
  }, [_vm._v("Podlahová plocha")]), _c('div', {
    staticClass: "input-with-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.podlahova_plocha,
      expression: "form.podlahova_plocha",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "id": "floor-area"
    },
    domProps: {
      "value": _vm.form.podlahova_plocha
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "podlahova_plocha", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_vm._v("m²")])])]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "room-count"
    }
  }, [_vm._v("Počet izieb")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.pocet_izieb,
      expression: "form.pocet_izieb",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "id": "room-count"
    },
    domProps: {
      "value": _vm.form.pocet_izieb
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "pocet_izieb", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _vm.form.pravny_stav !== 'rozostavana' ? _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "occupancy-year"
    }
  }, [_vm._v("Rok kolaudácie")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.rok_kolaudacie,
      expression: "form.rok_kolaudacie",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "min": "1000",
      "max": "9999",
      "step": "1",
      "id": "occupancy-year"
    },
    domProps: {
      "value": _vm.form.rok_kolaudacie
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "rok_kolaudacie", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'property_year_round_housing',
      "init-value": _vm.form.celorocne_byvanie,
      "options": _vm.booleanChoices,
      "normal": "",
      "name": 'Celoročné bývanie'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'celorocne_byvanie');
      }
    }
  })], 1)])]) : _vm._e(), _c('section', {
    staticClass: "property-card"
  }, [_c('div', {
    staticClass: "property-card-heading"
  }, [_c('span', {
    staticClass: "property-card-step"
  }, [_vm._v(_vm._s(_vm.typeData === 'land' ? 3 : 4))]), _vm._m(3)]), _c('div', {
    staticClass: "property-grid"
  }, [_c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'property_typ_vlastnictva',
      "init-value": _vm.translateOwnershipFromDbValue(),
      "options": _vm.getOwnerChoices(),
      "normal": "",
      "name": 'Vlastník'
    },
    on: {
      "select": function select($event) {
        return _vm.changeOwner($event);
      }
    }
  })], 1), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "owner-share"
    }
  }, [_vm._v("Podiel vlastníka")]), _c('div', {
    staticClass: "input-with-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.spoluvlastnicky_podiel_vlastnika,
      expression: "form.spoluvlastnicky_podiel_vlastnika",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": "0.01",
      "id": "owner-share"
    },
    domProps: {
      "value": _vm.form.spoluvlastnicky_podiel_vlastnika
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "spoluvlastnicky_podiel_vlastnika", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_vm._v("%")])])]), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'property_acquisition_title',
      "init-value": _vm.form.titul_nadobudnutia,
      "options": _vm.acquisitionTitles,
      "normal": "",
      "name": 'Titul nadobudnutia'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'titul_nadobudnutia');
      }
    }
  })], 1), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "acquisition-date"
    }
  }, [_vm._v("Dátum nadobudnutia")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.datum_nadobudnutia,
      expression: "form.datum_nadobudnutia"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "date",
      "id": "acquisition-date"
    },
    domProps: {
      "value": _vm.form.datum_nadobudnutia
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "datum_nadobudnutia", $event.target.value);
      }
    }
  })])]), _vm.ownerHelper === 'other' ? _c('div', {
    staticClass: "property-related-person"
  }, [_c('client-picker', {
    attrs: {
      "client-init": _vm.otherOwnerId,
      "complex": ""
    },
    on: {
      "client-picked": function clientPicked($event) {
        return _vm.setClient($event);
      },
      "busy": function busy($event) {
        _vm.clientBusy = $event;
      }
    }
  }), _vm.clientBusy ? _c('p', {
    staticClass: "light-text"
  }, [_vm._v("Pred uložením nehnuteľnosti dokončite údaje klienta alebo sa vráťte k výberu.")]) : _vm._e()], 1) : _vm._e()]), _c('section', {
    staticClass: "property-card property-card--optional"
  }, [_c('button', {
    staticClass: "property-card-toggle",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.advancedOpen = !_vm.advancedOpen;
      }
    }
  }, [_vm._m(4), _c('span', {
    staticClass: "property-card-chevron",
    "class": {
      open: _vm.advancedOpen
    }
  }, [_vm._v("⌄")])]), _c('v-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.advancedOpen,
      expression: "advancedOpen"
    }],
    staticClass: "property-advanced-content"
  }, [_c('div', {
    staticClass: "property-grid"
  }, [_c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'property_tarcha_banky',
      "init-value": _vm.form.tarcha_banka,
      "options": _vm.banks,
      "normal": "",
      "name": 'Banka existujúcej ťarchy'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'tarcha_banka');
      }
    }
  })], 1), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "orient-zost"
    }
  }, [_vm._v("Orientačný zostatok")]), _c('div', {
    staticClass: "input-with-suffix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.tarcha_orientacny_zostatok,
      expression: "form.tarcha_orientacny_zostatok",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.01",
      "id": "orient-zost"
    },
    domProps: {
      "value": _vm.form.tarcha_orientacny_zostatok
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "tarcha_orientacny_zostatok", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_vm._v("EUR")])])])]), _c('div', {
    staticClass: "input-group property-full-width"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "easements"
    }
  }, [_vm._v("Vecné bremená")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.vecne_bremena,
      expression: "form.vecne_bremena",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "text-input w-input property-textarea",
    attrs: {
      "maxlength": "2000",
      "id": "easements",
      "placeholder": "Napr. právo doživotného bývania; nechajte prázdne, ak sa na LV nenachádza."
    },
    domProps: {
      "value": _vm.form.vecne_bremena
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "vecne_bremena", $event.target.value.trim());
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])])], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "property-card-heading"
  }, [_c('span', {
    staticClass: "property-card-step"
  }, [_vm._v("1")]), _c('div', [_c('h3', [_vm._v("Základné údaje")]), _c('p', [_vm._v("Údaje používané pri výpočte aj vo všetkých bankových žiadostiach.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "property-card-heading"
  }, [_c('span', {
    staticClass: "property-card-step"
  }, [_vm._v("2")]), _c('div', [_c('h3', [_vm._v("Adresa a kataster")]), _c('p', [_vm._v("LV, parcela a katastrálne územie sa vypĺňajú aj pri byte a dome.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "property-card-heading"
  }, [_c('span', {
    staticClass: "property-card-step"
  }, [_vm._v("3")]), _c('div', [_c('h3', [_vm._v("Parametre nehnuteľnosti")]), _c('p', [_vm._v("Tieto polia požaduje najmä Prima banka a ČSOB.")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', [_vm._v("Vlastníctvo")]), _c('p', [_vm._v("Podiel a titul nadobudnutia pomôžu pri záložnej časti žiadosti.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('strong', [_vm._v("Ťarchy a vecné bremená")]), _c('small', [_vm._v("Voliteľné, ale dôležité pri refinancovaní alebo ďalšom poradí záložného práva.")])]);

}]

export { render, staticRenderFns }